import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";

import Landing from "@/pages/Landing";
import About from "@/pages/About";
import Membership from "@/pages/Membership";
import Committee from "@/pages/Committee";
import Contact from "@/pages/Contact";
import Apply from "@/pages/Apply";
import Events from "@/pages/Events";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminApplications from "@/pages/AdminApplications";
import AdminMembers from "@/pages/AdminMembers";
import AdminEvents from "@/pages/AdminEvents";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <BrowserRouter>
                    <Toaster position="top-right" richColors />
                    <Routes>
                        <Route path="/" element={<Landing />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/membership" element={<Membership />} />
                        <Route path="/committee" element={<Committee />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/apply" element={<Apply />} />
                        <Route path="/events" element={<Events />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/applications" element={<AdminApplications />} />
                        <Route path="/admin/members" element={<AdminMembers />} />
                        <Route path="/admin/events" element={<AdminEvents />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
